import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import * as $ from 'jquery';


@Component({
  selector: 'app-deactivate1',
  templateUrl: './deactivate1.component.html',
  styleUrls: ['./deactivate1.component.scss']
})
export class Deactivate1Component implements OnInit {

  res: any = "";
  submitted4 = false;
  mobilno: any;
  contenthide = true;
  successcontenthide = true;
  iphonecontenthide = true;

  captchaRes: any;
  isDisabledCap = true;
  isDisabledTick = false;
  capOption: any;
  checked = false;

  ///////////////////////
  deactivate1 = new FormGroup({
    jioId: new FormControl(),
    // captchaTick: new FormControl()
  })

  deactivate2 = new FormGroup({
    SelectModel: new FormControl(),
    // Model : new FormControl(),
  });

  isDisabled1: boolean;
  isDisabled2: boolean;
  isDisabled3: boolean;
  isDisabled4: boolean;
  res1: any;
  res2: any;
  res3: any;
  res4: any;

  feed: any;
  i: any;
  loading1 = false;
  loading2 = false;
  loading3 = false;

  submitted1 = false;
  submitted2 = false;
  // submittedRecaptcha = false;

  isReadOnly = true;
  isReadOnly2 = false;
  isReadOnly3 = false;

  data: any;
  otherReasons: any;
  screenW: boolean;

  // recaptcha = new FormGroup({
  //   recaptchaReactive: new FormControl(),
  // })

  flag9 = 0;
  flag1 = 0;
  message: any;
  countryCode: any;
  concatNum: any;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private dialog: MatDialog, private route: ActivatedRoute,
    public dialog_1: MatDialogRef<TemplateRef<any>>, public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>, public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>) { }

  // config: NgbModalConfig, private dialog: NgbModal, private router: Router) {
  //   config.backdrop = 'static';
  //   config.keyboard = false;  
  //   config.windowClass = 'custom-class'
  //  }

  ngOnInit() {

    // console.log(window.screen.width);
    if (window.screen.width >= 1100) {  //class=aside visibility for desktop
      this.screenW = true;
    }
    else {
      this.screenW = false;
    }

    this.loading1 = false;
    this.loading2 = false;
    this.loading3 = false;

    this.checked = false;
    this.isDisabledCap = true;
    this.isDisabledTick = false;
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }

    //////////// intialize dummy value
    this.res1 = {
      "deviceNameList": [
        { "deviceName": "123456" },
        { "deviceName": "123456" },
        { "deviceName": "123456" }
      ]
    }

    //////////// intialize dummy value
    this.res2 = {
      "devicesInfoList": [
        { "deviceName": "123456" },
        { "deviceName": "123456" },
        { "deviceName": "123456" }
      ]
    }
    this.route.fragment.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })


    this.modal1 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]]
    })

    // document.getElementById("Dummy").click();

    this.deactivate1 = this.formBuilder.group({
      // jioId: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],
      jioId: ['', [Validators.required,Validators.pattern('^[0-9]*$'),Validators.minLength(4), Validators.maxLength(15)]],
      // captchaTick: ['', [Validators.required]]
    });

    // this.recaptcha = this.formBuilder.group({
    //   recaptchaReactive: ['', [Validators.required]]
    // })

    this.submitted1 = false;
    this.submitted2 = false;
    // this.submittedRecaptcha = false;
    // this.recaptcha.reset();
    this.flag9 = 0;
    this.flag1 = 0;

    document.getElementById("error1").style.display = "none";
    document.getElementById("error2").style.display = "none";
    document.getElementById("goHome").style.display = "none";
    document.getElementById("errorM").style.display = "none";

    document.getElementById("buttonD2").style.display = "none";
    document.getElementById("buttonD3").style.display = "none";

    document.getElementById("model").style.display = "none";
    document.getElementById("radioB").style.display = "none";

    // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    // document.getElementById("buttonD2").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD2").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD2").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD2").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD2").style.color = "#707070";

    // document.getElementById("buttonD3").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD3").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD3").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD3").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD3").style.color = "#707070";

    // document.getElementById("buttonD4").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD4").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD4").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD4").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD4").style.color = "#707070";

    this.isDisabled1 = true;
    this.isDisabled2 = true;
    this.isDisabled3 = true;
    this.isDisabled4 = true;

    this.isReadOnly = true;
  }

  //edit kirtana
  showModal(content) {
    this.dismissmodal();
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  modal1 = new FormGroup({
    jioId: new FormControl()
  });
  loginPage() {
    // //console.log("redirect to login page");

    this.router.navigateByUrl("/login")
  }
  getlink(successcontent, failurecontent, content) {
    this.submitted4 = true;
    if (this.modal1.invalid) {
      document.getElementById("errormessage").style.display = "block";
    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = { "phoneno": this.modal1.value.jioId }
      this.mobilno = this.modal1.value.jioId;
      this.http.post(environment.validate, data).subscribe(
        data => {
          //console.log(data);

          this.res = data;
          if (this.res.status == "OK") {

            this.contenthide = true;
            this.successcontenthide = false;
            this.dialog_2 = this.dialog.open(successcontent, {
              panelClass: 'success-dialog-container',
              restoreFocus: true,
              role: 'dialog',
              autoFocus: false,
              disableClose: true,
              // height:'200px'
              // padding-left: '17%';
              // padding-right: '17%';

            })


          }
          else {
            // this.dialog.closeAll()
            // this.dialog_1.close();
            // this.dialog_1.afterClosed().subscribe(result => {
            //   //console.log("closed dialog");

            // });
            this.contenthide = true;

            this.dialog_3 = this.dialog.open(failurecontent, {
              panelClass: 'failure-dialog-container',

              // backdropClass: 'failurebackdrop'
              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

              // }


            })
          }

          ;
        })
    }
  }

  dismissmodal() {
    this.dialog.closeAll()
    this.modal1.reset();

  }




  openapk() {

    this.dismissmodal();
    // window.open('./assets/apk/JioID-1.0.4.apk');
    window.open('./assets/apk/JioSecureID.apk');
  }

  openipapk() {
    this.dismissmodal();
    window.open(environment.iOSlink);
  }

  ///////////////////////////////
  get f1() { return this.deactivate1.controls; }
  get f2() { return this.deactivate2.controls; }

  get f() { return this.modal1.controls; }
  // get f9() { return this.recaptcha.controls; }

  // disable1(){
  //   return this.isDisabled1;
  // }

  deactClick() {
    //console.log("enterv here");
    window.location.reload();
    // this.router.navigateByUrl("/Deactivate")
  }

  first() {
    console.log(this.checked);

    this.isDisabledTick = false;
    this.checked = false;
    this.capOption = null;
    // this.initialCaptcha();
    this.captchaRes = {
      "image": null,
      "options": [null, null, null, null]
    }
    this.flag9 = 0;  //captcha flag

    document.getElementById("buttonD1").style.display = "block";
    document.getElementById("buttonD2").style.display = "none";
    document.getElementById("buttonD3").style.display = "none";

    document.getElementById("model").style.display = "none";
    document.getElementById("radioB").style.display = "none";
    //console.log((this.deactivate1.value.jioId).length);
    // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD1").style.color = "#707070";

    this.isDisabled1 = true;

    if ((this.deactivate1.value.jioId).length >= 4 && (this.deactivate1.value.jioId).length <= 15) {
      this.flag1 = 1;
      document.getElementById("errorM").style.display = "none";
    }

    else {
      this.flag1 = 0;
      document.getElementById("model").style.display = "none";
      document.getElementById("radioB").style.display = "none";
      document.getElementById("errorM").style.display = "block";
    }
    this.firstProceed();
  }

  second() {
    //console.log(this.res1);

    document.getElementById("buttonD2").style.display = "block";
    document.getElementById("buttonD3").style.display = "none";


    document.getElementById("radioB").style.display = "none";
    //console.log(this.deactivate2.value.SelectModel);

    // document.getElementById("buttonD2").style.backgroundColor = "#aa9f9fbd";
    // document.getElementById("buttonD2").style.borderColor = "#aa9f9fbd";
    document.getElementById("buttonD2").style.backgroundColor = "#D7D7D7";
    document.getElementById("buttonD2").style.borderColor = "#D7D7D7";
    document.getElementById("buttonD2").style.color = "#707070";

    this.isDisabled2 = true;

    if ((this.deactivate2.value.SelectModel) == "Select") {
      // document.getElementById("buttonD2").style.backgroundColor = "#aa9f9fbd";
      // document.getElementById("buttonD2").style.borderColor = "#aa9f9fbd";
      document.getElementById("buttonD2").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD2").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD2").style.color = "#707070";

      this.isDisabled2 = true;
      document.getElementById("radioB").style.display = "none";
      document.getElementById("buttonD3").style.display = "none";

    }
    else if ((this.deactivate2.value.SelectModel)) {
      document.getElementById("buttonD2").style.backgroundColor = "#224797";
      document.getElementById("buttonD2").style.borderColor = "#224797";
      document.getElementById("buttonD2").style.color = "white";

      this.isDisabled2 = false;
    }
  }
  gohome() {

    this.router.navigateByUrl('/Introduction');
  }
  third(h) {
    //console.log(h);
    this.data = h;
    this.isDisabled3 = false;
    document.getElementById("buttonD3").style.backgroundColor = "#224797";
    document.getElementById("buttonD3").style.borderColor = "#224797";
    document.getElementById("buttonD3").style.color = "white";

  }

  samePage() {
    window.location.reload();
  }

  initialCaptcha() {

    // this.checked = false;
    this.http.post(environment.captcha, {},
      {
        withCredentials: true
        // ,responseType: 'text'
      }).subscribe(
        data => {
          console.log(data);
          this.captchaRes = data;
        });
  }

  recaptchaFunct(isChecked, captchaD) { //for normal captcha
    if (!this.isDisabledTick) {
      console.log(isChecked);
      this.initialCaptcha();

      if (isChecked) {
        const dialog_ref = this.dialog.open(captchaD, {
          panelClass: 'customlink-dialog-container',

          disableClose: true,

          restoreFocus: false,
          role: 'dialog',
          autoFocus: false,

        })
      }
      else {
        // this.initialCaptcha();
        this.dialog.closeAll();
        this.flag9 = 0;
        this.capOption = null;
        this.isDisabled4 = true;
        document.getElementById("buttonD4").style.backgroundColor = "#D7D7D7";
        document.getElementById("buttonD4").style.borderColor = "#D7D7D7";
        document.getElementById("buttonD4").style.color = "#707070";
      }
    }
  }

  handleChange(option) {
    // console.log(option);
    this.capOption = option;
    this.isDisabledCap = false;
    document.getElementById("capbut").style.backgroundColor = "#224797";
    document.getElementById("capbut").style.borderColor = "#224797";
    document.getElementById("capbut").style.color = "white";
  }

  calculateEntypo(input) {
    var num = Number(input);
    // console.log(num);
    var num1 = Math.floor(num / 100);
    var num2 = num % 100;
    if (num1 > 93) {
      num1 = num1 + 33 + 104;
    } else {
      num1 = num1 + 33;
    }

    if (num2 > 93) {
      num2 = num2 + 33 + 104;
    } else {
      num2 = num2 + 33;
    }
    // console.log("res1: " + num1+ ", res2: "+ num2);
    var res1 = String.fromCharCode(num1);
    var res2 = String.fromCharCode(num2);
    return res1 + '' + res2;
  }

  capSub() {

    //  this.submittedRecaptcha = true;
    this.dialog.closeAll();

    if (!this.capOption) {
      this.flag9 = 0;
    }
    else {
      this.flag9 = 1;
    }
    this.isDisabledTick = true;   //disable captcha tick

    this.firstProceed();

    this.isDisabledCap = true;   // disable popup captcha image button
    document.getElementById("capbut").style.backgroundColor = "#D7D7D7";  // disable popup captcha image button
    document.getElementById("capbut").style.borderColor = "#D7D7D7";  // disable popup captcha image button
    document.getElementById("capbut").style.color = "#707070";  // disable popup captcha image button
  }

  firstProceed() {
    document.getElementById("buttonD1").style.display = "block";
    if (this.flag1 == 1 && this.flag9 == 1) {
      document.getElementById("buttonD1").style.backgroundColor = "#224797";
      document.getElementById("buttonD1").style.borderColor = "#224797";
      document.getElementById("buttonD1").style.color = "white";

      this.isDisabled1 = false;
    }
    else {
      document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
      document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
      document.getElementById("buttonD1").style.color = "#707070";

      this.isDisabled1 = true;
    }
  }

  onCountryChange(event){
    console.log("here is number " +event.dialCode);
    // localStorage.setItem("tempEvent",event.dialCode)
    this.countryCode = event.dialCode;
  }

  proceed(captchaD2) {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      // The viewport is less than 768 pixels wide
      $("#firstPart").css({
        "margin-bottom": "5%"
      })


    }
    this.submitted1 = true;

    // stop here if form is invalid
    if (this.deactivate1.invalid) {
      document.getElementById("errorM").style.display = "block";
      // return;
    }
    else {
      document.getElementById("errorM").style.display = "none";

      document.getElementById("error1").style.display = "none";


      //console.log(this.deactivate1.value.jioId);

      // if (this.deactivate1.value.jioId.length == 10) {
      this.loading1 = true;
      //console.log("enter");

      if(this.countryCode == 91){
        this.concatNum = this.deactivate1.value.jioId;
      }
      else if(this.countryCode){
        this.concatNum = "+"+this.countryCode+"-"+this.deactivate1.value.jioId;
      }
      else{
        this.concatNum = this.deactivate1.value.jioId;
      }

      console.log("this.concatNum = "+this.concatNum);

      var str1 = new String(environment.getDeviceName);
      var str2 = str1.concat(this.concatNum + "&captchaInput=" + this.capOption);
      //console.log(str2);

      this.http.get(str2, {
        headers: {
          'Content-Type': 'application/json'
        }
        , withCredentials: true
        // ,responseType: 'text'
      }).subscribe(
        data => {
          this.loading1 = false;
          this.submitted1 = false;
          //console.log(data);
          this.res1 = data;
          this.message = null;  //error message null

          if (this.res1.deviceNameList) {
            document.getElementById("error1").style.display = "none";  //hide error message
            this.isReadOnly2 = true;
            document.getElementById("buttonD1").style.display = "none";
            this.isDisabled1 = true;
            document.getElementById("model").style.display = "block";
            document.getElementById("buttonD2").style.display = "block";
            this.isDisabled2 = true;
          }
          else {
            this.message = "Something went wrong. ";
            document.getElementById("error1").style.display = "block";
          }

        }, err => {
          // console.log(err.error)
          // document.getElementById("error1").style.display = "block";
          /////////////////////////////////////////////////////////////////////////////
          this.loading1 = false;
          console.log(err.error)
          this.isDisabledTick = false;
          this.checked = false;
          this.capOption = null;
          this.flag9 = 0;
          this.firstProceed();
          // this.initialCaptcha();
          this.captchaRes = {
            "image": null,
            "options": [null, null, null, null]
          }

          if (err.error.errorCd == "0125") {
            this.message = "Incorrect CAPTCHA"
            const dialog_ref = this.dialog.open(captchaD2, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })
          }
          else if (err.error.errorCd == "1104") {
            this.message = "No Jio SecureID Account found for given number. ";
            document.getElementById('error1').style.display = 'block';
          }
          else if (err.error.errorCd == "3145") {
            this.message = "No active Jio SecureID account found on any device. ";
            document.getElementById('error1').style.display = 'block';
          }
          else {
            this.message = "Something went wrong. ";
            document.getElementById('error1').style.display = 'block';
          }

        });

    }
  }


  selectModel() {
    if (window.matchMedia("(min-width: 1200px)").matches) {
      // The viewport is less than 768 pixels wide
      $("#firstPart").css({
        "margin-bottom": "-1%"
      })


    }
    //console.log(this.res1);

    if ((this.deactivate2.value.SelectModel) == "Select") {
      document.getElementById("errorM2").style.display = "block";

    }
    else if ((this.deactivate2.value.SelectModel)) {
      this.loading2 = true;
      document.getElementById("errorM2").style.display = "none";

      document.getElementById("error2").style.display = "none";
      this.message = null;  //error message null
      //console.log(this.deactivate2.value.SelectModel);

      // if(this.deactivate2.value.SelectModel){
      // this.loading2 = true;

      //console.log(this.res2);

      // const formData = new FormData();
      // formData.append('deviceName', this.deactivate2.value.SelectModel);
      // formData.append('phonenr', this.deactivate1.value.jioId);

      let formData = {
        "deviceName": this.deactivate2.value.SelectModel
      }


      this.http.post(environment.getPersonData, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
        , withCredentials: true
        // ,observe: 'data' as 'response'
        // ,responseType: 'text'
      }).subscribe(
        data => {
          this.loading2 = false;
          // console.log(data.headers.keys());

          this.res2 = data;
          // console.log(this.res2);

          // this.loading2 = false;


          if (this.res2.devicesInfoList) {

            document.getElementById("selectOption").style.display = "none";
            document.getElementById("InputOption").style.display = "block";
            this.isReadOnly3 = true;


            document.getElementById("buttonD2").style.display = "none";
            this.isDisabled2 = true;
            document.getElementById("radioB").style.display = "block";
            document.getElementById("buttonD3").style.display = "block";
            this.isDisabled3 = true;
          }
          else {

            document.getElementById("selectOption").style.display = "none";
            document.getElementById("InputOption").style.display = "block";
            this.isReadOnly3 = true;

            document.getElementById("error2").style.display = "block";

            document.getElementById("buttonD2").style.display = "none";
            document.getElementById("goHome").style.display = "block";

          }

        }
        , err => {

      this.loading2 = false;

          if (err.error.errorCd == "0107") {
            this.message = "Selected make and model not correct. ";
            document.getElementById("selectOption").style.display = "none";
            document.getElementById("InputOption").style.display = "block";
            this.isReadOnly3 = true;

            document.getElementById("error2").style.display = "block";

            document.getElementById("buttonD2").style.display = "none";
            document.getElementById("goHome").style.display = "block";
          }
          else {
            // console.log(err.error)
            document.getElementById("selectOption").style.display = "none";
            document.getElementById("InputOption").style.display = "block";
            this.isReadOnly3 = true;

            document.getElementById("error2").style.display = "block";

            document.getElementById("buttonD2").style.display = "none";
            document.getElementById("goHome").style.display = "block";
          }
        });

    }
  }

  Model() {

    //console.log(this.res2);

    // console.log(this.data);
    //console.log("hiiii");
    this.loading3 = true;

    // this.loading3 = false;

    // const formData = new FormData();
    // formData.append('token', this.data.token);

    let formData = {
      "token": this.data.token
    }

    this.http.post(environment.disableAccount, formData, {
      headers: {
        'Content-Type': 'application/json'
      }
      , withCredentials: true
      , responseType: "text" as "json"
    }).subscribe(
      data => {
        this.loading3 = false;
        // console.log(data);

        this.res3 = data;
        // console.log(this.res3);

        // if (this.res3.result.message == "OK") {
        //   //console.log(this.res3.result.message);

        document.getElementById("firstPart").style.display = "none";

        document.getElementById("secondPart").style.display = "block";
        // }
        // else {
        // }

      }
      , err => {
        this.loading3 = false;
        // console.log(err.error)
        document.getElementById("firstPart").style.display = "none";
        document.getElementById("errorLast").style.display = "block";
      }
    );
  }

  onItemChange(e) {
    this.isReadOnly = true;

    this.isDisabled4 = false;

    // this.flag1 = 1;
    document.getElementById("buttonD4").style.backgroundColor = "#224797";
    document.getElementById("buttonD4").style.borderColor = "#224797";
    document.getElementById("buttonD4").style.color = "white";

    // console.log(e);
    this.feed = e;
    if (this.feed == "other") {
      this.isReadOnly = false;
    }

    // this.feedC();
  }

  dismissmodal2 () {
    this.dialog.closeAll()
    this.modal1.reset();

    //captcha
    this.isDisabledTick = false;
    this.checked = false;
    this.isDisabledCap = true;
  }

  scroll() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth', block: 'center' });
    // console.log(this.deactivate1.value.jioId);

  }

  // recaptchaFunct(captchaResponse: string) {
  //   // console.log(`Resolved response token: ${captchaResponse}`);
  //   // // console.log("heree   " +captchaResponse);
  //   // console.log(this.recaptcha.value.recaptchaReactive);

  //   this.submittedRecaptcha = true;

  //   if (this.recaptcha.invalid) {
  //     this.flag9 = 0;
  //     // document.getElementById("jdevicemake").style.display = "none";

  //     this.isDisabled4 = true;
  //     // document.getElementById("buttonD4").style.backgroundColor = "#aa9f9fbd";
  //     // document.getElementById("buttonD4").style.borderColor = "#aa9f9fbd";
  //     document.getElementById("buttonD4").style.backgroundColor = "#D7D7D7";
  //     document.getElementById("buttonD4").style.borderColor = "#D7D7D7";
  //     document.getElementById("buttonD4").style.color = "#707070";
  //     return;
  //   }
  //   else {
  //     this.flag9 = 1;
  //     // document.getElementById("jdevicemake").style.display = "block";

  //     this.feedC();
  //   }
  // }

  feedbackS() {
    //console.log(this.otherReasons);


    if (this.feed == "other") {
      if (this.otherReasons) {
        this.feed = this.otherReasons;
      }
      else {
        this.feed = "Other reasons"
      }
    }

    const formData = new FormData();
    formData.append('feedbackType', '0')
    formData.append('phoneNr', this.deactivate1.value.jioId);
    // formData.append('phoneNr', "9082451569");
    formData.append('content', this.feed);
    // formData.append('recaptchaInput', btoa(this.recaptcha.value.recaptchaReactive));  //base64 encode
    // formData.append('deviceMake', "");
    // formData.append('deviceModel', "");
    // formData.append('deviceOs', "");
    // formData.append('emailId', "");
    // formData.append('name', "");
    // formData.append('attachment',"");

    // let formData = {
    //   "content": this.feed,
    //   "phoneNumber": this.deactivate1.value.jioId

    // }

    // console.log(this.feed);


    this.http.post(environment.sendFeedback, formData, {
      headers: {
        // 'Content-Type': 'multipart/form-data; boundary=--------------------------077038073766403182958732',
      }
      // ,responseType: 'text'
      , withCredentials: true
    }).subscribe(
      data => {
        // console.log(formData);

        console.log(data);

        // this.res4 = data;
        // console.log(this.res4);


        // if (this.res4.status == "SUCCESS" && this.res4.data.message == "OK") {
        document.getElementById('errormsg').style.display = 'none';

        document.getElementById("secondPart").style.display = "none";

        document.getElementById("thirdPart").style.display = "block";

        this.isDisabled4 = true;
        // document.getElementById("buttonD1").style.backgroundColor = "#aa9f9fbd";
        // document.getElementById("buttonD1").style.borderColor = "#aa9f9fbd";
        document.getElementById("buttonD1").style.backgroundColor = "#D7D7D7";
        document.getElementById("buttonD1").style.borderColor = "#D7D7D7";
        document.getElementById("buttonD1").style.color = "#707070";


        // }

        // else {
        //   document.getElementById('success').style.display = 'none';

        //   document.getElementById('errormsg').style.display = 'block';
        // }

      }, err => {
        //console.log(err.error)
        document.getElementById('success').style.display = 'none';

        document.getElementById('errormsg').style.display = 'block';
      });
  }

  refreshpage() {
    location.reload();
  }

  sendphonelink1(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";

      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "0"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);

          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.contenthide = true;


            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,


            })
          }
          else {
            // this.dialog.closeAll()
            this.contenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        },
        err => {
          this.contenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        })
    }
  };
  sendphonelink2(successcontent, successlinksent, failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {


      document.getElementById("errormessage").style.display = "block";



    }
    else {

      document.getElementById("errormessage").style.display = "none";
      let data = {
        "phoneno": this.modal1.value.jioId,
        "flag": "1"
      }
      //console.log(data);
      this.http.post(environment.sendSms, data).subscribe(
        data => {
          //console.log(data);
          this.res = data;
          if (this.res.status == "SMS Send Successfully") {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(successlinksent, {
              panelClass: 'customlink-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })


          }
          else {
            // this.dialog.closeAll()
            this.iphonecontenthide = true;

            const dialog_ref = this.dialog.open(failurelinksent, {
              panelClass: 'custom-dialog-container',

              disableClose: true,

              restoreFocus: false,
              role: 'dialog',
              autoFocus: false,

            })

          }

          ;
        },
        err => {
          this.contenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        })
    }
  }
  showModal1(successcontent) {

    this.successcontenthide = false;
    this.dialog_2 = this.dialog.open(successcontent, {
      panelClass: 'success-dialog-container',
      restoreFocus: true,
      role: 'dialog',
      autoFocus: false,
      disableClose: true,
      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })

  }
  sendandroidphonelink(content) {
    this.successcontenthide = true;
    this.contenthide = false;
    this.dialog_1 = this.dialog.open(content, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  sendiphonelink(iphonecontent) {
    this.successcontenthide = true;

    this.iphonecontenthide = false;
    this.dialog_1 = this.dialog.open(iphonecontent, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      restoreFocus: true,
      role: 'dialog',
      disableClose: true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';

    })


  }
  sendlink1(successcontent, successlinksent, failurelinksent) {
    let data = {
      "phoneno": this.modal1.value.jioId,
      "flag": "0"
    }
    //console.log(data);
    this.http.post(environment.sendSms, data).subscribe(
      data => {
        //console.log(data);

        this.res = data;
        if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.successcontenthide = true;

          const dialog_ref = this.dialog.open(successlinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,


          })
        }
        else {
          // this.dialog.closeAll()
          this.successcontenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'customlink-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        }

        ;
      })
  };
  sendlink2(successcontent, successlinksent, failurelinksent) {
    let data = {
      "phoneno": this.modal1.value.jioId,
      "flag": "1"
    }
    //console.log(data);
    this.http.post(environment.sendSms, data).subscribe(
      data => {
        //console.log(data);
        this.res = data;
        if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.successcontenthide = true;

          const dialog_ref = this.dialog.open(successlinksent, {
            panelClass: 'custom-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })


        }
        else {
          // this.dialog.closeAll()
          this.successcontenthide = true;

          const dialog_ref = this.dialog.open(failurelinksent, {
            panelClass: 'custom-dialog-container',

            disableClose: true,

            restoreFocus: false,
            role: 'dialog',
            autoFocus: false,

          })

        }

        ;
      })
  }
}


